import script from "./ClientCabinetItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetItem.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetItem.vue?vue&type=style&index=0&id=f86c2da4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f86c2da4"]])

export default __exports__